import { useSession } from './state/useSession';
import logo from './assets/logo.png';
import { Button, Card, CardBody } from './ui';
import { LoginScreen } from './screens/LoginScreen';
import { MailScreen } from './screens/MailScreen';

export function App() {
	const session = useSession();

	if ('loading' === session.status) {
		return <div className="reading__empty">Loading…</div>;
	}

	if ('unreachable' === session.status) {
		return (
			<div className="login">
				<div className="login__card">
					<img className="login__logo" src={logo} alt="Keystone Management" />
					<Card>
						<CardBody>
							<p style={{ margin: 0 }}>The mail server is not responding.</p>
							<p className="ks-muted" style={{ margin: 0, fontSize: 13 }}>{session.error}</p>
							<Button onClick={session.retry}>Try again</Button>
						</CardBody>
					</Card>
				</div>
			</div>
		);
	}

	if ('signed-in' === session.status && session.data) {
		return <MailScreen session={session.data} onSignOut={() => void session.signOut()} />;
	}

	return <LoginScreen onSignedIn={session.adopt} />;
}
